/**
 * The window event that opens one of the job's documents on its documents screen, in All, from anywhere in the
 * workbench (the export history's Send back for review). The App answers it as Leave tour's way back to a document
 * (`requestTourReturn`): it leaves Job setup for the job's documents and selects the document once its batch is on
 * screen; a document that is no longer there (removed, purged) leaves the documents as they open.
 */
export const OPEN_DOCUMENT_EVENT = 'paige-open-document';

/** Asks the App to open the document. */
export function openDocument(documentId: string): void {
  window.dispatchEvent(new CustomEvent(OPEN_DOCUMENT_EVENT, { detail: documentId }));
}
